import { Select, Typography } from 'antd';
import React, { useState } from 'react';
import { ProfileProps } from '../../profile/ProfilePage';
import { useTranslation } from 'react-i18next';
import { CHINESE_SYMBOL, ENGLISH_SYMBOL } from '../../../i18n';
import { useUpdateLanguage } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks';
import styled from 'styled-components';

const { Text } = Typography;
const Wrapper = styled.div`
  padding: 12px 20px;
  display: flex;
  align-content: center;
  gap: 6px;
  background-color: #fff;

  & > * {
    max-width: 400px;
  }
`;
const SubtitleWrapper = styled.div`
  padding-left: 24px;
  background-color: var(--neutral-3);
  display: flex;
  align-items: center;
`;
export const Language = ({ data }: ProfileProps): JSX.Element => {
  const { t, i18n } = useTranslation();
  const { token } = useKeycloakReady();
  const [locale, setLocale] = useState<string | undefined>();
  const { shouldFetch } = useUpdateLanguage(
    { name: 'useUpdateLanguage', params: { locale } },
    locale ?? ENGLISH_SYMBOL,
    token || '',
    {
      revalidateOnFocus: false,
      onSuccess: async () => {
        await i18n.changeLanguage(locale);
        shouldFetch(false);
      },
    },
  );
  const options: { label: string; value: string }[] = [
    { label: 'English', value: ENGLISH_SYMBOL },
    { label: '繁體中文', value: CHINESE_SYMBOL },
  ];
  const getDefaultLanguage = (locale: string) => {
    return options.find((a) => a.value === locale);
  };
  return (
    <>
      {data?.localization && (
        <>
          <SubtitleWrapper>
            <Text>{t('profile.language')}</Text>
          </SubtitleWrapper>
          <Wrapper>
            <Select
              labelInValue={true}
              defaultValue={getDefaultLanguage(data.localization)}
              options={options}
              onChange={(e) => {
                setLocale(e.value);
                shouldFetch(true);
              }}
            />
          </Wrapper>
        </>
      )}
    </>
  );
};
